import React from "react";
import { Box, CircularProgress, Divider, makeStyles, Typography } from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";
import EventSeatIcon from "@material-ui/icons/EventSeat";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import { getTranslation } from "../../../heplers/translationHelper";

const useStyles = makeStyles(() => ({
  root: {
    background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 2px 12px rgba(0,68,103,0.08)",
    border: "1px solid #e8edf2",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  sectionLabel: {
    fontSize: "10px",
    fontWeight: "700",
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    color: "#8a9bb0",
  },
  occupancyRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  ringWrapper: {
    position: "relative",
    width: "52px",
    height: "52px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  ringBg: {
    position: "absolute",
    top: 0,
    left: 0,
    color: "rgba(0,68,103,0.1)",
  },
  ringFill: {
    position: "absolute",
    top: 0,
    left: 0,
    color: "#FA8900",
  },
  percentText: {
    fontSize: "11px",
    fontWeight: "800",
    color: "#004467",
    zIndex: 1,
    lineHeight: 1,
  },
  occupancyLabel: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#8a9bb0",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    lineHeight: 1,
    marginBottom: "3px",
  },
  occupancyValue: {
    fontSize: "22px",
    fontWeight: "800",
    color: "#004467",
    lineHeight: 1,
  },
  statRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 0",
  },
  statLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  iconDot: {
    width: "28px",
    height: "28px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  statLabel: {
    fontSize: "12px",
    color: "#667a8a",
    fontWeight: "500",
  },
  statValue: {
    fontSize: "16px",
    fontWeight: "800",
    color: "#004467",
  },
}));

const StatRow = ({ icon, iconBg, iconColor, label, value }) => {
  const classes = useStyles();
  return (
    <Box className={classes.statRow}>
      <Box className={classes.statLeft}>
        <Box className={classes.iconDot} style={{ backgroundColor: iconBg }}>
          {React.cloneElement(icon, { style: { fontSize: 15, color: iconColor } })}
        </Box>
        <Typography className={classes.statLabel}>{label}</Typography>
      </Box>
      <Typography className={classes.statValue}>{value ?? 0}</Typography>
    </Box>
  );
};

const Progressbar = ({ stats }) => {
  const classes = useStyles();
  const { maxCapacity, numberOfGroups, numberOfPersons, percentage } = stats;
  const pct = Math.min(parseFloat((percentage || "0").toString().replace("%", "").trim()) || 0, 100);

  return (
    <Box className={classes.root}>
      <Typography className={classes.sectionLabel}>
        {getTranslation("Occupancy", "Occupancy", "Occupancy")}
      </Typography>

      <Box className={classes.occupancyRow}>
        <Box className={classes.ringWrapper}>
          <CircularProgress variant="determinate" value={100} size={52} thickness={4.5} className={classes.ringBg} />
          <CircularProgress variant="determinate" value={pct} size={52} thickness={4.5} className={classes.ringFill} />
          <Typography className={classes.percentText}>{Math.round(pct)}%</Typography>
        </Box>
        <Box>
          <Typography className={classes.occupancyLabel}>
            {getTranslation("Filled", "Filled", "Filled")}
          </Typography>
          <Typography className={classes.occupancyValue}>{percentage || "0%"}</Typography>
        </Box>
      </Box>

      <Divider style={{ backgroundColor: "#e8edf2" }} />

      <Box>
        <StatRow icon={<TrendingUpIcon />} iconBg="rgba(0,68,103,0.08)" iconColor="#004467"
          label={getTranslation("Capacity", "Capacity", "Capacity")} value={maxCapacity} />
        <Divider style={{ backgroundColor: "#f0f4f8" }} />
        <StatRow icon={<PeopleIcon />} iconBg="rgba(250,137,0,0.1)" iconColor="#FA8900"
          label={getTranslation("Persons", "Persons", "Persons")} value={numberOfPersons} />
        <Divider style={{ backgroundColor: "#f0f4f8" }} />
        <StatRow icon={<EventSeatIcon />} iconBg="rgba(67,160,71,0.1)" iconColor="#43a047"
          label={getTranslation("Tables", "Tables", "Tables")} value={numberOfGroups} />
      </Box>
    </Box>
  );
};

export default Progressbar;
